function refreshCartJS() {
  const cartSlide = document.querySelector('cart-slide');
  if (cartSlide) {
    if (cartSlide.refreshCart) cartSlide.refreshCart();
    // Open cart drawer if not active
    if (cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  }
}

function customMiniCartRelatedProductAddToCart(id, quantity, openCart) {
  // Validate variant ID
  if (!id || id === '' || id === 'undefined' || id === 'null') {
    console.error('Invalid variant ID:', id);
    alert('Please select a product variant');
    return;
  }

  // Validate quantity
  if (!quantity || 1 > quantity || isNaN(quantity)) {
    console.error('Invalid quantity:', quantity);
    alert('Please enter a valid quantity');
    return;
  }

  const formData = {
    'items': [{
      'id': String(id), // Ensure ID is a string
      'quantity': parseInt(quantity, 10)
    }]
  };

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
        return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
        });
    }
    return response.json();
  })
  .then(response => {
    // Refresh cart
    refreshCartJS();
    if (openCart) {
       // logic to open cart is handled in refreshCartJS usually, but we can force it
       const cartSlide = document.querySelector('cart-slide');
       if (cartSlide && !cartSlide.classList.contains('active') && cartSlide.toggleCart) {
           cartSlide.toggleCart();
       }
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    alert(error.message || error);
  });
}

function ajaxCartCall() {
    refreshCartJS();
}

function miniCartRefresh(openCart) {
    refreshCartJS();
}

// COM-65 — Back to top button
(function () {
  var btn = document.querySelector('.back-to-top');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.classList.toggle('back-to-top--show', window.scrollY > 400);
  }, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

// COM-66 — Sticky Add to Cart bar
(function () {
  var bar = document.getElementById('sticky-atc');
  if (!bar) return;

  // Both mobile (product-block) and desktop (product-section) forms are in the DOM.
  // Observe all ATC buttons — the hidden one never intersects so never unlocks the bar.
  var allBtns = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"] .submit_add_cart'));
  if (!allBtns.length) return;

  var stickyBtn = bar.querySelector('.sticky-atc__btn');
  var stickyPrice = bar.querySelector('.sticky-atc__price');
  var stickySelects = bar.querySelector('.sticky-atc__selects');

  var seenMap = {};    // buttonIndex -> bool: has entered viewport at least once
  var outMap = {};     // buttonIndex -> bool: currently out of viewport

  // Reset seen state on viewport resize (prevents Shopify editor mobile-switch false trigger)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      seenMap = {};
      outMap = {};
      bar.classList.remove('sticky-atc--show');
      liftFloatingElements(false);
    }, 200);
  });

  function updateBarVisibility() {
    // Show if any button has been seen AND is now out of view (scrolled past)
    var shouldShow = allBtns.some(function (_, i) { return seenMap[i] && outMap[i]; });
    var changed = bar.classList.contains('sticky-atc--show') !== shouldShow;
    bar.classList.toggle('sticky-atc--show', shouldShow);
    if (changed) liftFloatingElements(shouldShow);
    if (shouldShow) syncState();
    
  }

  function liftFloatingElements(visible) {
    var offset = (bar.offsetHeight + 14) + 'px';
    var vh = window.innerHeight;

    function liftEl(el) {
      if (!el || el === bar || bar.contains(el)) return;
      var rect = el.getBoundingClientRect();
      // Only lift elements in the bottom 25% of the screen — avoids mid-right widgets (Salesfire)
      if (rect.top < vh * 0.75) return;
      el.style.transition = el.style.transition || 'bottom 0.3s ease';
      el.style.bottom = visible ? offset : '';
    }

    function scanFixed() {
      // Named selectors for known bottom widgets (Salesfire intentionally excluded — it sits mid-right)
      ['.back-to-top', '#ll-launcher', '.ll-launcher', '[id^="ll-sdk"]',
       '[id*="loyalty"]', '[class*="loyalty-launcher"]'
      ].forEach(function (sel) {
        try { document.querySelectorAll(sel).forEach(liftEl); } catch (e) {}
      });

      // General catch-all: direct body children with position:fixed in bottom 25% of screen
      document.querySelectorAll('body > *').forEach(function (el) {
        if (el === bar) return;
        try {
          if (window.getComputedStyle(el).position === 'fixed') liftEl(el);
        } catch (e) {}
      });
    }

    scanFixed();
    // Re-scan after short delays to catch async-injected widgets (e.g. LoyaltyLion)
    if (visible) {
      setTimeout(scanFixed, 400);
      setTimeout(scanFixed, 1200);
    }
  }

  // Format a price amount using the same decimal/thousands separators as a DOM price string.
  // e.g. formatLikeDomPrice(4256, "3.254,00 zł") → "4.256,00 zł"
  //      formatLikeDomPrice(849,  "£869.00")     → "£849.00"
  function formatLikeDomPrice(amount, templateStr) {
    if (!templateStr) return null;
    var t = templateStr.trim();
    var m = t.match(/([\d]+(?:[.,][\d]+)*)/);
    if (!m) return null;
    var numStr = m[1];
    var lastDot = numStr.lastIndexOf('.');
    var lastComma = numStr.lastIndexOf(',');
    var decSep = lastComma > lastDot ? ',' : '.';
    var thouSep = decSep === ',' ? '.' : ',';
    var parts = amount.toFixed(2).split('.');
    var intStr = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return t.replace(numStr, intStr + decSep + parts[1]);
  }

  // When sticky ATC changes variant, we set price immediately from __luffVariants.
  // The DOM may lag behind. _priceBeforeSticky prevents the interval from reverting
  // the sticky back to the stale DOM value before Surge updates it.
  var _priceBeforeSticky = null;

  // COG-2909 — Price sync: read from the visible ATC form's section every 200ms.
  function getProductSectionPrice() {
    var forms = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]'));
    var vf = forms.find(function (f) { return f.offsetParent !== null; });
    if (!vf) return '';
    var scope = vf.closest('[id^="shopify-section-"]') || vf.parentElement;
    if (!scope) return '';
    // Surge renders price as <div class="price">VALUE</div> inside <div class="price-block">
    // (no .money span — | money filter outputs plain text in this theme)
    var el = scope.querySelector('.price-block .price')
      || scope.querySelector('.price__amount .money')
      || scope.querySelector('.price .money')
      || scope.querySelector('.money');
    if (!el) return '';
    var money = el.querySelector('.money');
    return (money ? money : el).textContent.trim();
  }

  setInterval(function () {
    if (!stickyPrice || !bar.classList.contains('sticky-atc--show')) return;
    var p = getProductSectionPrice();
    if (!p || p === stickyPrice.textContent) return;
    // If _priceBeforeSticky is set, the sticky was last updated from __luffVariants.
    // Don't revert to the stale DOM value — only update if DOM has actually moved.
    if (_priceBeforeSticky && p === _priceBeforeSticky) return;
    stickyPrice.textContent = p;
    if (_priceBeforeSticky) _priceBeforeSticky = null; // DOM caught up, clear guard
  }, 200);

  // Build compact <select> elements in the sticky bar from embedded product options/variants
  function buildStickySelects() {
    if (!stickySelects || !window.__luffVariants || !window.__luffProductOptions) return;
    var opts = window.__luffProductOptions;
    if (!opts.length || (opts.length === 1 && window.__luffVariants.length === 1 && window.__luffVariants[0].title === 'Default Title')) return;
    stickySelects.innerHTML = '';
    opts.forEach(function (optName, i) {
      var seen = {}, values = [];
      window.__luffVariants.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (val && !seen[val]) { seen[val] = true; values.push(val); }
      });
      if (!values.length) return;
      var select = document.createElement('select');
      select.className = 'sticky-atc__variant-select';
      select.setAttribute('aria-label', optName);
      select.dataset.optionIndex = i;
      values.forEach(function (val) {
        var opt = document.createElement('option');
        opt.value = val; opt.textContent = val;
        select.appendChild(opt);
      });
      stickySelects.appendChild(select);
    });
  }

  // Update sticky selects to reflect a given variant
  function syncSelectsFromVariant(variantId) {
    if (!stickySelects || !window.__luffVariants) return;
    var v = window.__luffVariants.find(function (x) { return String(x.id) === String(variantId); });
    if (!v) return;
    Array.from(stickySelects.querySelectorAll('.sticky-atc__variant-select')).forEach(function (sel, i) {
      var val = v['option' + (i + 1)];
      if (val && sel.value !== val) sel.value = val;
    });
  }

  // Flag to prevent syncState overwriting sticky selects while we're driving a change
  var _fromStickySelect = false;

  // Sticky select change: set ALL page selectors to target values first (silently),
  // Fire change on the SPECIFIC option that changed, after silently setting all others.
  // Previously we always fired on option[0] which caused Surge to treat every sticky
  // change as a Size change and reset other options to defaults.
  function onStickySelectChange(ev) {
    var changedSelect = ev && ev.target;
    var changedIdx = changedSelect ? parseInt(changedSelect.dataset.optionIndex, 10) : 0;
    var selects = Array.from(stickySelects.querySelectorAll('.sticky-atc__variant-select'));
    var chosen = selects.map(function (s) { return s.value; });

    _fromStickySelect = true;

    // 1. Directly set ALL form variant ID inputs — guarantees correct add-to-cart.
    // Look up the matching variant; if not found (option combo unavailable) still
    // proceed so Surge handles availability, but skip the direct ID set.
    var match = (window.__luffVariants || []).find(function (v) {
      return chosen.every(function (val, i) { return v['option' + (i + 1)] === val; });
    });
    if (match) {
      document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (inp) {
        inp.value = String(match.id);
      });
    }

    // 2. Update page option selectors via Surge's own custom elements.
    // variant-dropdown / variant-pills appear in DOM order = option index order.
    // This avoids depending on name attributes or data-option-index (both unreliable).
    var idx = isNaN(changedIdx) ? 0 : changedIdx;
    var vf = (function() {
      var fs = Array.from(document.querySelectorAll('form[data-type="add-to-cart-form"]'));
      return fs.find(function(f) { return f.offsetParent !== null; }) || fs[0];
    })();
    if (vf) {
      var sectionScope = vf.closest('[id^="shopify-section-"]') || vf.parentElement;
      var optionEls = sectionScope ? Array.from(sectionScope.querySelectorAll('variant-dropdown, variant-pills')) : [];
      var chosenJson = JSON.stringify(chosen);
      optionEls.forEach(function (optEl, i) {
        var val = chosen[i];
        if (!val) return;
        var shouldFire = (i === idx);
        if (optEl.tagName === 'VARIANT-DROPDOWN') {
          optEl.setAttribute('data-current-set', chosenJson);
          if (shouldFire) {
            // Try clicking the matching option item first (triggers Surge's full price render)
            var optionItem = optEl.querySelector('[data-value="' + val.replace(/"/g, '\\"') + '"], .option-dropdown__item[data-value], li[data-value]');
            if (!optionItem) {
              // Fallback: find any clickable child with text matching the value
              var allItems = Array.from(optEl.querySelectorAll('li, button, [role="option"], .dropdown-item'));
              optionItem = allItems.find(function(el) { return el.textContent.trim() === val; });
            }
            if (optionItem) {
              optionItem.click();
            } else {
              optEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        } else {
          // variant-pills: find the radio with the target value and check it
          var radio = optEl.querySelector('input[value="' + val.replace(/"/g, '\\"') + '"]');
          if (radio) {
            radio.checked = true;
            if (shouldFire) radio.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (shouldFire) {
            optEl.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    // 4. Immediately set price from __luffVariants formatted like the DOM price.
    // Record current price as _priceBeforeSticky — the interval will refuse to
    // revert the sticky to this value while the DOM lags behind Surge's update.
    if (match && stickyPrice && window.__luffVariants) {
      // Guard must use the CURRENT DOM price (not sticky price) so repeated changes
      // don't chain incorrectly: DOM is always the "before" baseline.
      _priceBeforeSticky = getProductSectionPrice() || stickyPrice.textContent;
      var domPriceNow = _priceBeforeSticky;
      var immediate = formatLikeDomPrice(match.price / 100, domPriceNow || stickyPrice.textContent);
      if (immediate) stickyPrice.textContent = immediate;
    }

    // 5. Release flag after Surge's variant:change event chain has settled
    setTimeout(function () { _fromStickySelect = false; }, 1500);
  }

  if (stickySelects) {
    buildStickySelects();
    stickySelects.addEventListener('change', onStickySelectChange);
  }

  function syncState(e) {
    // Button state
    var activeBtn = allBtns.find(function (b) { return b.offsetParent !== null; }) || allBtns[0];
    var soldOut = activeBtn && activeBtn.disabled;
    stickyBtn.disabled = soldOut;
    stickyBtn.textContent = soldOut
      ? ((activeBtn.querySelector('.button--text') || {}).textContent || 'Sold Out').trim()
      : 'Add to Cart';

    if (_fromStickySelect) return; // sticky-select changes manage their own price/selects

    // Variant selects sync
    var variantId = (e && e.detail && e.detail.variantId) || null;
    if (!variantId) {
      var idInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (idInput) variantId = idInput.value;
    }
    if (variantId) syncSelectsFromVariant(variantId);

    // Price on initial bar show — interval handles all subsequent updates.
    if (!e) {
      var domP = getProductSectionPrice();
      if (domP && stickyPrice) stickyPrice.textContent = domP;
    }
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = allBtns.indexOf(entry.target);
        if (entry.isIntersecting) seenMap[i] = true;
        outMap[i] = !entry.isIntersecting;
      });
      updateBarVisibility();
    }, { threshold: 0 });
    allBtns.forEach(function (btn) { observer.observe(btn); });
  }

  stickyBtn.addEventListener('click', function () {
    var activeBtn = allBtns.find(function (b) { return b.offsetParent !== null && !b.disabled; });
    if (activeBtn) activeBtn.click();
  });

  document.addEventListener('variant:change', syncState);   // Surge's actual event (product.js)
  document.addEventListener('variant:changed', syncState);  // fallback
  document.addEventListener('variantChange', syncState);    // fallback
})();

/* COM-101 — Delay Loyalty Club and Chatra chat launcher on mobile by 30 seconds
 * Both widgets inject asynchronously so we suppress them via an injected
 * <style> tag that is removed after the delay, triggering a smooth fade-in.
 * Desktop is unaffected.
 */
(function () {
  if (window.innerWidth > 768) return;

  var style = document.createElement('style');
  style.id = 'com-101-widget-delay';
  style.textContent =
    '#ll-launcher, .ll-launcher, [id^="ll-sdk"], [id*="loyalty"], [class*="loyalty-launcher"],' +
    '#chatra, [id^="chatra"], .chatra-side-button {' +
    '  opacity: 0 !important;' +
    '  pointer-events: none !important;' +
    '  transition: opacity 0.4s ease !important;' +
    '}';
  document.head.appendChild(style);

  setTimeout(function () {
    var el = document.getElementById('com-101-widget-delay');
    if (el) el.remove();
  }, 30000);
})();
